import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

// Slug 유효성 검사 훅
export const useSlugValidation = (slug, isEditMode) => {
  const [isCheckingSlug, setIsCheckingSlug] = useState(false);
  const [slugAvailable, setSlugAvailable] = useState(null);
  const [slugError, setSlugError] = useState('');

  useEffect(() => {
    if (!slug || isEditMode) {
      setSlugAvailable(isEditMode ? true : null);
      setSlugError('');
      return;
    }

    const handler = setTimeout(async () => {
      if (slug.length < 3 || !/^[a-z0-9-]+$/.test(slug)) {
        setSlugError('3자 이상, 영문 소문자, 숫자, 하이픈만 사용 가능합니다.');
        setSlugAvailable(false);
        return;
      }

      setIsCheckingSlug(true);
      try {
        const { data, error } = await supabase
          .from('portfolios')
          .select('slug')
          .eq('slug', slug)
          .maybeSingle();
        
        if (error) {
          if (error.code === 'PGRST116') {
            setSlugAvailable(true);
            setSlugError('');
          } else {
            setSlugError('주소 확인 중 오류 발생');
            setSlugAvailable(false);
          }
        } else {
          setSlugAvailable(!data);
          setSlugError(data ? '이미 사용 중인 주소입니다.' : '');
        }
      } catch (err) {
        setSlugError('주소 확인 중 오류 발생');
        setSlugAvailable(false);
      } finally {
        setIsCheckingSlug(false);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [slug, isEditMode]);

  return { isCheckingSlug, slugAvailable, slugError };
};
